const BASE_URL = '/'
const SIGN_IN = BASE_URL
const MICROSOFT_CALLBACK = `${BASE_URL}callback`
const PASSWORD_RECOVERY = `${BASE_URL}password-recovery`
const NEW_PASSWORD = `${BASE_URL}new-password/:key`
const HOME = `${BASE_URL}home`
const SYNC_DATA = `${BASE_URL}/syncdata`
const USERS = `${BASE_URL}/users`
const PROFILES = `${BASE_URL}/profiles`
const REPORT = `${BASE_URL}report/:hash`
const ETHOS = `${BASE_URL}ethos`
const ETHOS_COMPANIES = `${ETHOS}/companies`
const ETHOS_REPORTS = `${ETHOS}/reports`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  SIGN_IN,
  MICROSOFT_CALLBACK,
  PASSWORD_RECOVERY,
  NEW_PASSWORD,
  HOME,
  ETHOS_COMPANIES,
  ETHOS_REPORTS,
  SYNC_DATA,
  USERS,
  PROFILES,
  REPORT,
  UNAUTHORIZED,
}
